import { render, staticRenderFns } from "./TheHeaderDropdownTasks.vue?vue&type=template&id=419ce3d7&"
import script from "./TheHeaderDropdownTasks.vue?vue&type=script&lang=js&"
export * from "./TheHeaderDropdownTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports